'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactTable = require('react-table');

var _reactTable2 = _interopRequireDefault(_reactTable);

var _FontIcon = require('material-ui/FontIcon');

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _reactRouterDom = require('react-router-dom');

require('react-table/react-table.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GenericMaterialsList = function (_React$Component) {
	_inherits(GenericMaterialsList, _React$Component);

	function GenericMaterialsList() {
		_classCallCheck(this, GenericMaterialsList);

		return _possibleConstructorReturn(this, (GenericMaterialsList.__proto__ || Object.getPrototypeOf(GenericMaterialsList)).apply(this, arguments));
	}

	_createClass(GenericMaterialsList, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var data = this.props.genericMaterials.map(function (trans) {
				return _extends({ _id: trans.id }, trans);
			});

			var columns = [{
				id: 'edit',
				width: 62,
				Cell: function Cell(col) {
					return _react2.default.createElement(
						_reactRouterDom.Link,
						{ to: '/genericmaterials/edit/' + col.original.id },
						_react2.default.createElement(
							_FontIcon2.default,
							{ className: 'material-icons' },
							'edit'
						)
					);
				}
			}, {
				Header: 'Nome',
				accessor: 'name',
				minWidth: 300
			}, {
				Header: 'Descrição',
				accessor: 'description',
				minWidth: 300
			}, {
				Header: 'Mensagem',
				accessor: 'message',
				minWidth: 300
			}, {
				Header: 'Forma de exibição',
				width: 100,
				Cell: function Cell(col) {
					var displayType = void 0;

					if (col.original.display === 'WEB') {
						displayType = 'Web';
					} else if (col.original.display === 'VIDEO') {
						displayType = 'Vídeo';
					} else if (col.original.display === 'STREAM') {
						displayType = 'Stream';
					} else {
						displayType = 'Áreas';
					}

					return _react2.default.createElement(
						'span',
						null,
						displayType
					);
				}
			}, {
				Header: 'Categoria',
				width: 100,
				Cell: function Cell(col) {
					var categoryType = void 0;

					if (col.original.category === 'VIDEO') {
						categoryType = 'Vídeo';
					} else if (col.original.category === 'MATERIAL') {
						categoryType = 'Material';
					} else if (col.original.category === 'COURSES') {
						categoryType = 'Cursos';
					}

					return _react2.default.createElement(
						'span',
						null,
						categoryType
					);
				}
			}, {
				Header: 'Destaque',
				accessor: 'featured',
				width: 100,
				Cell: function Cell(col) {
					return col.original.featured ? 'Sim' : 'Não';
				}
			}, {
				Header: 'url',
				accessor: 'url'
			}, {
				Header: 'Início',
				accessor: 'startDate',
				width: 100,
				Cell: function Cell(col) {
					return _react2.default.createElement(
						'span',
						null,
						(0, _moment2.default)(col.original.startDate).format('DD/MM/YYYY HH:mm')
					);
				}
			}, {
				Header: 'Fim',
				accessor: 'endDate',
				width: 100,
				Cell: function Cell(col) {
					return _react2.default.createElement(
						'span',
						null,
						col.original.endDate ? (0, _moment2.default)(col.original.endDate).format('DD/MM/YYYY HH:mm') : ''
					);
				}
			}, {
				Header: 'Modificada em',
				accessor: 'updatedAt',
				width: 100,
				Cell: function Cell(col) {
					return _react2.default.createElement(
						'span',
						null,
						(0, _moment2.default)(col.original.updatedAt).format('DD/MM/YYYY HH:mm')
					);
				}
			}, {
				id: 'deeplink',
				width: 62,
				Cell: function Cell(col) {
					return _react2.default.createElement(
						_IconButton2.default,
						{ iconClassName: 'material-icons', onClick: function onClick() {
								return _this2.props.onClickDeepLink(col.original.id);
							} },
						'link'
					);
				}
			}];

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(_reactTable2.default, {
					data: data,
					columns: columns,
					loading: this.props.loading,
					previousText: 'Anterior',
					nextText: 'Pr\xF3xima',
					loadingText: 'Carregando...',
					noDataText: 'N\xE3o foram encontradas materiais gen\xE9ricos para este filtro',
					pageText: 'P\xE1gina',
					ofText: 'de',
					rowsText: 'linhas',
					showPaginationBottom: true,
					width: 100,
					defaultPageSize: 20
				})
			);
		}
	}]);

	return GenericMaterialsList;
}(_react2.default.Component);

exports.default = GenericMaterialsList;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/genericMaterials/GenericMaterialsList.js
// module id = 2584
// module chunks = 0